/**
 * Words for a ledger line's kind (TMMRSL-0080). The known kinds use tmm-product-admin's labels.
 * An unknown kind keeps its raw value on the line and shows the generic label.
 */
import type { TFunction } from 'i18next';

const LINE_KIND_KEYS: Record<string, string> = {
  REVENUE_SHARE: 'ledger.lineKind.REVENUE_SHARE',
  MARGIN: 'ledger.lineKind.MARGIN',
  AFFILIATE_COMMISSION: 'ledger.lineKind.AFFILIATE_COMMISSION',
  COMMISSION_DEDUCTION: 'ledger.lineKind.COMMISSION_DEDUCTION',
  PROCESSING_FEE: 'ledger.lineKind.PROCESSING_FEE',
  AFFILIATE_BONUS: 'ledger.lineKind.AFFILIATE_BONUS',
  MINIMUM_SHORTFALL: 'ledger.lineKind.MINIMUM_SHORTFALL',
  ADJUSTMENT: 'ledger.lineKind.ADJUSTMENT',
  REVERSAL: 'ledger.lineKind.REVERSAL',
  VOID: 'ledger.lineKind.VOID',
  PAYOUT: 'ledger.lineKind.PAYOUT',
  PAYOUT_MANUAL: 'ledger.lineKind.PAYOUT_MANUAL',
  PAYOUT_RETURNED: 'ledger.lineKind.PAYOUT_RETURNED',
  COLLECTION: 'ledger.lineKind.COLLECTION',
};

/** A line's kind in words. A kind this console doesn't know is the generic label. */
export function lineKindLabel(kind: string, t: TFunction): string {
  const key = LINE_KIND_KEYS[kind];
  return key ? t(key) : t('ledger.lineKind.OTHER');
}
